import chroma from "chroma-js";
import { IoIosAddCircle } from "react-icons/io";
import styled, { keyframes } from "styled-components";

interface TagProps {
  color: string;
}

export const rotate = keyframes`
   0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

export const TagsContainer = styled.div`
  display: flex;
  width: 200px;
  align-items: center;
  gap: 0.5rem;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 10rem;
  gap: 0.5rem;
`;

export const ColumnTagList = styled(TagList)`
  width: 100%;
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: ${rotate} 1.5s linear infinite;
`;

export const ButtonContainer = styled.div`
  display: flex;
`;

export const OpenModalAdd = styled(IoIosAddCircle)`
  cursor: pointer;
  color: ${(props) => props.theme.colors.primaryBlue.main};
  font-size: 1.4rem;
  &:not(:first-child) {
    margin-left: 0.5rem;
  }
`;

export const TagItem = styled.div<TagProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => chroma(props.color).alpha(0.2).hex()};
  border-radius: 5px;
  color: ${(props) => props.color};
  min-height: 1.5rem;
  gap: 0.2rem;
`;

export const TagNameContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 85%;
  padding: 0.25rem 0;
  padding-left: 0.2rem;
`;

export const TagCloseContainer = styled.div<TagProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${(props) => chroma(props.color).alpha(0.1).hex()};
  }
  width: 30px;
  height: 100%;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const Close = styled.span<TagProps>`
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: ${(props) => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  font-weight: bold;
  width: fit-content;
`;

export const AddTagSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
  .search-input {
    width: 100% !important;
  }
`;

export const ModalTitle = styled.h2`
  color: ${(props) => props.theme.colors.primaryBlue.main};
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
  padding: 0;
`;

export const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
`;

export const LabelNewTag = styled.span`
  color: ${(props) => props.theme.colors.primaryBlue.main};
  font-size: 0.9rem;
`;

export const LabelNewTagBold = styled(LabelNewTag)`
  font-weight: bold;
  font-size: 0.9rem;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const InputColor = styled.input.attrs({ type: "color" })`
  align-self: center;
  justify-self: center;
  border: 1px solid #000;
  all: unset;
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  width: 100%;
  .input-search {
    width: 100%;
  }
`;





